/**
 * @typedef {object} DataForCart
 * @property {string} itemId - id продукта (из api)
 * @property {string} name - имя продукта для отображения в нотификации
 * @property {string} brand - бренд продукта для отображения в нотификации
 * @property {Array<object>} media - массив медиа (первое изображение будет отображено в нотификации)
 * @property {object} attributes - объект атрибутов (первые варианты будут отражены в нотификации)
 * @property {boolean} configurable - требует ли показа превью с вариантами
 * @property {boolean} needOnlineConsultation - ??
 */

/**
 * Возвращает данные которые будут переданы кнопке из модуля cart
 * @param {Ref<DataForCart>} data
 */
export const useDataCart = (data) => {
  const dataCart = computed(() => {
    const { itemId, name } = unref(data) || {}

    return {
      id: itemId,
      name,
    }
  })

  return {
    dataCart,
  }
}
